import ClientCharts from './ClientCharts';
export default ClientCharts;
